const TYPE = {
  UNRESTRICTED: 'Unrestricted',
  TIME_RESTRICTED: 'TimeRestricted',
};

const DAY_OF_WEEK = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
};

export default class RestrictionAreaDaySpecification {
  constructor(data) {
    if (!Object.values(DAY_OF_WEEK).includes(data.dayOfTheWeek)) {
      throw new Error(
        `RestrictionAreaDaySpecification: incorrect dayOfTheWeek ${data.dayOfTheWeek}`,
      );
    }
    if (!Object.values(TYPE).includes(data.type)) {
      throw new Error(`RestrictionAreaDaySpecification: incorrect type ${data.type}`);
    }

    if (data.type === TYPE.TIME_RESTRICTED) {
      if (typeof data.from !== 'string') {
        throw new Error('RestrictionArea: incorrect from');
      }
      if (typeof data.to !== 'string') {
        throw new Error('RestrictionArea: incorrect to');
      }
    }

    Object.assign(this, data);
  }

  dayOfTheWeek = null;

  type = null;

  from = null;

  to = null;

  static TYPE = TYPE;

  static DAY_OF_WEEK = DAY_OF_WEEK;
}



// WEBPACK FOOTER //
// ./src/models/RestrictionAreaDaySpecification.js